import { SchoolService, BaseService } from "@/services/school.service";

const EventService = {
    getAll () {
        return SchoolService.getAll("events")
    },

    add(payload) {
        return SchoolService.create("events", payload)
    },

    update(object) {
        return SchoolService.update("events", object.identifier, object)
    },

    delete(object) {
        return SchoolService.delete("events", object.identifier, null)
    },

    // pupils

    getPupils(object) {
        return SchoolService.getAll("events/" + object.identifier + "/pupils")
    },

    deletePupil(result, object) {
        return SchoolService.delete("events/" + result.identifier + "/pupils", object.identifier, null) 
     },

     addPupil(payload) {
        return SchoolService.create("events/pupils", payload)
    },
     
}

export { EventService };